export default {
  token() {
    return localStorage.getItem("token");
  }
};
